import React, { type ChangeEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import NumberFormat from "react-number-format";

import { Box, Checkbox, TextField } from "@mui/material";
import { FormikProps } from "formik";

import { FormValues } from "../schemas";

interface Props {
  formik: FormikProps<FormValues>;
  disabled?: boolean;
}

export const VAT: React.FC<Props> = ({ formik, disabled }) => {
  const { t } = useTranslation("debt");
  const [includeVat, setIncludeVat] = useState(!!formik.values.vat);

  useEffect(() => {
    setIncludeVat(!!formik.values.vat);
  }, [formik.values.vat]);

  const handleVatCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    setIncludeVat(checked);
    if (!checked) {
      formik.setFieldValue("vat", null);
    } else {
      formik.setFieldValue("vat", 0.18);
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
      <Checkbox checked={includeVat} onChange={handleVatCheckboxChange} name="includeVat" disabled={disabled} />
      <NumberFormat
        name="vat"
        label={t("debtSection.vatRate")}
        thousandSeparator={false}
        isNumericString
        variant="outlined"
        placeholder="0.18"
        disabled={!includeVat || disabled}
        error={formik.touched.vat && Boolean(formik.errors.vat)}
        helperText={formik.touched.vat && formik.errors.vat}
        decimalScale={2}
        sx={{
          flex: 1,
          ".MuiInputBase-input": {
            padding: "9.5px 8px"
          }
        }}
        allowNegative={false}
        customInput={TextField}
        value={formik.values.vat ?? ""}
        onValueChange={({ value }) => {
          formik.setFieldValue("vat", value ? Number(value) : null);
        }}
      />
    </Box>
  );
};
